import React, { Component } from 'react';
import UtilsAPI from '../utils/UtilsAPI';
import packageInfos from '../../package.json';

import './PageFooter.css';
import brandingConfig from '../branding/branding.json';
import brandingStyles from '../branding/brandingStyles';

class PageFooter extends Component {

    constructor() {
        super();
        this.state = {
            apiVersion: '',
            uiVersion: packageInfos.version,
        };
    }

    componentWillMount() {
        UtilsAPI.getAPIVersion()
        .then(res => {
            this.setState({
                apiVersion: res.version,
            });
        })
        .catch(() => {
            this.setState({
                apiVersion: 'unable to retrieve version',
            });
        });
    }

    render() {
        return (
            <div className="row page-footer" style={brandingStyles.fontColor}>
                <p>
                  {
                      brandingConfig.footerElements.map(
                      element => (
                        React.createElement(
                          element.type,
                          element.props,
                          element.content.replace('{YEAR}', new Date().getFullYear())
                        )
                      )
                      )
                  }
                </p>
                <p className="footer-small">
                  {`Versions: UI:${this.state.uiVersion}
                  API:${this.state.apiVersion}`}
                </p>
            </div>
        );
    }
}

export default PageFooter;



/** WEBPACK FOOTER **
 ** ./src/components/PageFooter.js
 **/